import './App.css';
import GeneralContainer from './continer';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ["IBM Plex Sans Arabic"]
  },
});
function App() {
  return (
    <>
      <main>
        <ThemeProvider theme={theme}>
          <GeneralContainer/>
        </ThemeProvider>
      </main>
    </>
  );
}

export default App;
